var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronTriangleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.401 6.569c-.047.03-.892.863-1.877 1.851-1.642 1.645-1.792 1.804-1.792 1.889a.38.38 0 0 0 .03.15c.076.142-.031.138 3.782.138 3.176 0 3.57-.005 3.654-.045.104-.049.171-.175.145-.274-.009-.035-.842-.889-1.852-1.898-1.418-1.417-1.855-1.838-1.92-1.85a.229.229 0 0 0-.17.039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronTriangleUp);
export default __webpack_public_path__ + "static/media/chevronTriangleUp.4f5365d929af96a6c1e9c989ec891b78.svg";
export { ForwardRef as ReactComponent };